import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from "react-select"
// import { Modal } from 'antd'

import { notifOps, usePet } from '../../modules'
import { login, logout, setuser } from '../../store/actions'

import Modal from '../resusable/modal'

const LockSession = ({ visible, onPerform }) => {
    const [password, setPwd] = useState('')

    const { user } = useSelector(state => state.application)
    const dispatch = useDispatch()

    const onComplete = ({ data }, notif) => {
        notif('Session restored', notifOps('success'))
        dispatch(login(data.token))
        onPerform()
    }

    const logOut = () => dispatch(logout())

    const [{ loading }, execute] = usePet('userLogin', {
        username: user.username, 
        password: password,
        app: 'pos'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Logging In...' }, bypassLock: true })

    const onKeyUp = e => {
        if (e.keyCode === 13)
            execute()
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            closable={ false }
            modalStyle={{ zIndex: '10001' }}
            title="Session Locked"
            visible={visible}>
            <div className="w-full bg-white">
                <p className="text-sm font-light text-gray-700 mb-3">Please re-enter your password to continue.</p>
                <div className="w-full px-3 mb-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Password
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-password"
                        type="password"
                        name="password"
                        value={password}
                        onKeyUp={ onKeyUp }
                        onChange={ e => setPwd(e.target.value) }
                        placeholder="********" />
                </div>
            </div>
            <div className="flex justify-end pt-3">
                <button disabled={ loading } onClick={ logOut } type="submit" className="text-white hisani-btn-green mr-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Log Out</button>
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Login</button>
            </div>
        </Modal>
    )
}

export default LockSession